import { TEMPLATE_REGISTRY } from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { TemplateDefinition } from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { GraphicOrganizersActivities } from "@/types/models";

const buildTemplateList = ({
  isStudent = false,
  isStudentPreviewOn = false,
  fetchedGraphicOrganizerResponseData,
}: {
  isStudent?: boolean;
  isStudentPreviewOn?: boolean;
  fetchedGraphicOrganizerResponseData?: GraphicOrganizersActivities | undefined;
}) => {
  if (isStudent || isStudentPreviewOn) {
    const fetchedIdentifiers =
      fetchedGraphicOrganizerResponseData?.graphic_organizers?.map((template) =>
        template.graphic_organizer_type.replace("graphic_organizer_", ""),
      ) || [];

    if (fetchedIdentifiers.length > 0) {
      return (
        Object.values(TEMPLATE_REGISTRY) as TemplateDefinition<any>[]
      ).filter((template) =>
        fetchedIdentifiers.includes(template.seti_identifier),
      );
    }

    return [];
  }
  return Object.values(TEMPLATE_REGISTRY);
};

export default buildTemplateList;
